import withTransformMenuData from "@utils/withTransformMenuData"
import withTransformMultipleDevicesProducts from "@utils/withTransformMultipleDevicesProducts"
import Products from "@views/Products"
import { graphql } from "gatsby"
import { compose } from "recompose"

export const query: any = graphql`
  query ProductsByDevice($deviceSlug: String) {
    contentfulGlobalSettings(internalTitle: { eq: "uag global settings" }) {
      ...GlobalSettingsCollectionFields
    }

    productsWithOneDevice: allContentfulProduct(
      filter: { device: { slug: { eq: $deviceSlug } } }
    ) {
      nodes {
        ...ProductDataFields
      }
    }

    productsWithManyDevices: allContentfulProduct(
      filter: { devices: { elemMatch: { slug: { eq: $deviceSlug } } } }
    ) {
      nodes {
        ...ProductDataFields
      }
    }

    contentfulDevice(slug: { eq: $deviceSlug }) {
      collectionFooter {
        id
        __typename
        content {
          raw
          references {
            ... on ContentfulAsset {
              contentful_id
              id
              __typename
              title
              description
              file {
                url
              }
            }
          }
        }
        h3Color
        h4Color
        h6Color
        minimalPadding
        padLeft
        padRight
        topPadding
        topPaddingMobile
        bottomPadding
        bottomPaddingMobile
      }
      collectionBannerType
      bannerImage {
        file {
          url
        }
      }
      mobileBannerImage {
        file {
          url
        }
      }
      bannerHeader
      bannerSubheader {
        bannerSubheader
      }
      paragraphHeader
      paragraphBody {
        paragraphBody
      }
      paragraphAsymmetricalSplit
    }
  }
`

export default compose(
  withTransformMultipleDevicesProducts,
  withTransformMenuData
)(Products) as any
